import { Component, Input, OnInit } from '@angular/core';
import { VECTORES_PAGO, VectorPago } from '../../../../../_models/perfil-cliente/vectore-perfil-crezcamos';
@Component({
  selector: 'app-vactores-pago',
  templateUrl: './vactores-pago.component.html',
  styleUrls: ['./vactores-pago.component.scss']
})
export class VactoresPagoComponent implements OnInit {
  @Input() informacionPerfil: any;
  vectoresPago: VectorPago[] = [];
  arrayTitleColumns: string[] = VECTORES_PAGO;

  ngOnInit(): void {   
    this.vectoresPago = this.informacionPerfil.vectoresPagos.map(item => {
      const vectores = item.vectores.reduce((acc, v, index) => {
        const key = `v${index + 1}`;
        acc[key] = v[`V${index + 1}`] || '-';
        return acc;
      }, { v1: '-', v2: '-', v3: '-', v4: '-', v5: '-', v6: '-' });
      return {
        rol: item.participacion,
        ...vectores,
        ult: vectores.v6
      } as VectorPago;
    });
  }
}
